import { AxiosError } from 'axios';
import ValidationError from '../errors/validation';

const parseValidationError = (error: AxiosError) => {
  const { response } = error;

  if (response) {
    const { status, data } = response;

    if (status === 400) {
      throw new ValidationError(data);
    }
  }

  throw error;
};

export default parseValidationError;
